import { EventBus } from '../plugins/event-bus'
import { isPhotoActionAllowed, likePhotoErrorMessages } from '@/helpers/actions'

export const likePhotoMixin = {
  data() {
    return {
      likePhotoBusy: false,
      likePhotoId: null
    }
  },
  methods: {
    async likePhoto(event, value, photoId, photographerId, from, feedId) {
      event.preventDefault()
      const canLikeIndex = isPhotoActionAllowed(this.me, photographerId, false)
      if (typeof canLikeIndex === 'number') {
        EventBus.$emit('snackbar', {
          text: likePhotoErrorMessages(canLikeIndex),
          color: 'info'
        })
      } else {
        const data = {
          value,
          id: photoId,
          from
        }
        if (from === 'feeds') {
          data.feedId = feedId
        }
        try {
          this.likePhotoBusy = true
          this.likePhotoId = photoId
          await this.$store.dispatch('photos/like', data)
          await this.$auth.fetchUser()
        } catch (error) {
          this.$asa.appInsights('Mixins: likePhotoMixin.js - method: likePhoto', error)
        } finally {
          this.likePhotoBusy = false
          this.likePhotoId = null
        }
      }
    }
  }
}
